export default (superClass) => {
    return class extends superClass {
        get setupFee() {
            return this._data.setup_fee;
        }
    
        get setupFeeString() {
            return this.formatCurrency(this.setupFee);
        }
    }
}